module.exports = __webpack_public_path__ + "img/cashback-active.db943688.svg";